import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUserProfile,
  fetchConnectedAccountURL,
  updateUserProfile,
  updateUserProfilePassword,
  fetchConnectedAccountCallback,
  fetchBrandLabels,
  refreshAccountLabels
} from './userProfileActions';
import { logout } from '../app/appSlice';
import { IUserProfile } from './types';

export const initialState: IUserProfile = {
  email: '',
  username: '',
  restricted: false,
  connectedAccount: {
    url: '',
    isConnected: false,
    availableAccounts: undefined,
    brandLabels: undefined
  }
};

export const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUserProfile.fulfilled, (state, { payload }) => {
      return {
        ...state,
        username: payload.username,
        email: payload.email,
        restricted: payload.restricted
      };
    });
    builder.addCase(logout, () => {
      return {
        ...initialState
      };
    });
    builder.addCase(updateUserProfile.fulfilled, (state, { payload }) => {
      return {
        ...state,
        ...payload
      };
    });
    builder.addCase(
      fetchConnectedAccountURL.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          connectedAccount: {
            ...state.connectedAccount,
            url: payload.data.data
          }
        };
      }
    );
    builder.addCase(fetchBrandLabels.fulfilled, (state, { payload }: any) => {
      return {
        ...state,
        connectedAccount: {
          ...state.connectedAccount,
          brandLabels: [...payload]
        }
      };
    });
    builder.addCase(refreshAccountLabels.pending, (state: any) => {
      return {
        ...state,
        connectedAccount: {
          ...state.connectedAccount,
          brandLabels: undefined
        }
      };
    });

    builder.addCase(
      refreshAccountLabels.fulfilled,
      (state, { payload }: any) => {
        return {
          ...state,
          connectedAccount: {
            ...state.connectedAccount,
            brandLabels: [...payload]
          }
        };
      }
    );
    builder.addCase(fetchConnectedAccountCallback.fulfilled, (state) => {
      return {
        ...state,
        connectedAccount: {
          ...state.connectedAccount,
          isConnected: true
        }
      };
    });
    builder.addCase(
      updateUserProfilePassword.fulfilled,
      (state, { payload }) => {
        return {
          ...state,
          ...payload,
          restricted: false
        };
      }
    );
  }
});

export default userProfileSlice.reducer;
